// Helper functions สำหรับจัดการ localStorage with expiration
export const setWithExpiration = (key: string, value: any, expirationMinutes: number) => {
    const now = new Date();
    const item = {
        value: value,
        expiration: now.getTime() + (expirationMinutes * 60 * 1000)
    };
    localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiration = (key: string) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    try {
        const item = JSON.parse(itemStr);
        const now = new Date();

        if (now.getTime() > item.expiration) {
            localStorage.removeItem(key);
            return null;
        }

        return item.value;
    } catch (error) {
        localStorage.removeItem(key);
        return null;
    }
};